import { useMemo } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Box from '@deprecated-ui/statics/Box';
import color from '@deprecated-ui/_style/color';
import { useTheme } from 'styled-components';
import { Page, PageTheme } from 'config/theme';
import Image from 'global/Image';
import { Footer, Wrapper, Header } from './styled';
import { DATA_CY_DOCUMENT_LAYOUT } from './__tests__/constant';

const DocumentLayout = ({
  children,
  noBox = false,
  noAuth = false,
  className = '',
}) => {
  const date = new Date();
  const year = date.getFullYear();
  const theme: any = useTheme();
  const customPageTheme: PageTheme = theme;

  const stockbitLogo = useMemo(
    () =>
      customPageTheme.page === Page.privacyDark
        ? '/images/stockbit-white.svg'
        : '/images/stockbit.svg',
    [customPageTheme.page],
  );

  return (
    <Wrapper className={className} data-cy={DATA_CY_DOCUMENT_LAYOUT}>
      <Header
        align="center"
        direction="row"
        justify="space-between"
        // @ts-expect-error
        mx="auto"
        p="20px 10px"
        style={{ maxWidth: '930px' }}
      >
        <Link href="/">
          <a>
            <Image
              id="header-stockbit-logo"
              src={stockbitLogo}
              height="40px"
              alt="Stockbit"
            />
          </a>
        </Link>
        {!noAuth && (
          <Flex direction="row" justify="center" align="center">
            <Link href="/login">
              <a>
                {/* @ts-expect-error */}
                <Button type="borderless" mr="16px" mt="8px">
                  <Text weight="bold" family="bold" color={color.pinkSwan}>
                    Login
                  </Text>
                </Button>
              </a>
            </Link>
            <Link href="/register">
              <a>
                {/* @ts-expect-error */}
                <Button type="primary" mt="8px">
                  <Text family="bold" color="#fff">
                    Register
                  </Text>
                </Button>
              </a>
            </Link>
          </Flex>
        )}
      </Header>
      {/* @ts-expect-error */}
      <Flex mx="auto" mb="24px" style={{ maxWidth: '930px' }}>
        {noBox ? children : <Box style={{ width: '100%' }}>{children}</Box>}
      </Flex>
      <Flex>
        <Footer>
          2013-{year} Stockbit ·
          <Link href="/about">
            <a>About</a>
          </Link>
          ·
          <Link href="/contact">
            <a>Contact</a>
          </Link>
          <a href="https://help.stockbit.com/id">Help</a>·
          <Link href="/rules">
            <a>House Rules</a>
          </Link>
          ·
          <Link href="/terms">
            <a>Terms</a>
          </Link>
          ·
          <Link href="/privacy">
            <a>Privacy</a>
          </Link>
        </Footer>
      </Flex>
    </Wrapper>
  );
};

DocumentLayout.propTypes = {
  children: PropTypes.node.isRequired,
  noBox: PropTypes.bool,
  noAuth: PropTypes.bool,
};

DocumentLayout.defaultProps = {
  noBox: false,
  noAuth: false,
};

export default DocumentLayout;
